import { observer } from 'mobx-react';
import { useResolvedPath } from 'react-router-dom';
import { Loader } from '@servicetitan/web-components';
import { CenteredSpinner } from '@servicetitan/marketing-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { TransparentMarketingStore } from '../../stores/transparent-marketing.store';
import { CenteredError } from '../../../../../common/components/centered-error/centered-error';
import { AppStore } from '../../../../../common/stores/app.store';

export const TransparentMarketingPage = provide({ singletons: [TransparentMarketingStore] })(
    observer(() => {
        const [{ src }, { appConfigs }] = useDependencies(TransparentMarketingStore, AppStore);

        const basename = useResolvedPath({
            pathname: '',
        }).pathname;

        return (
            <Loader
                src={src}
                basename={basename}
                data={{
                    environmentTag: appConfigs.environmentTag,
                }}
                errorFallback={<CenteredError />}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
